import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class ASTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Alarm Server" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { actionColumn: 'Alarm Server kontaktieren', descriptionColumn: 'Aktivieren Sie die Alarmserver-Funktion' },
        { actionColumn: 'Alarm Server Address', descriptionColumn: 'Type in the IP Address of your Alarm Server - e.g. your Smarthome.' },
        { actionColumn: 'Server Port', descriptionColumn: 'Geben Sie den TCP-Port ein, auf dem Ihr Alarmserver lauscht.' },
        { actionColumn: 'Server Pfad', descriptionColumn: 'Geben Sie die URL ein, die Ihr Server zu sehen erwartet.' },
        { actionColumn: 'Query', descriptionColumn: 'Sie können optionale Parameter an die URL anhängen.' },
        { actionColumn: 'Authentifizierung', descriptionColumn: 'Fügen Sie Ihr Server-Login in die URL ein.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

ASTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(ASTable)
